<template>
    <div class="teams-list mt-2">
        <div class="row">
            <div class="col-6" v-for="team in this.teams">
                <div class="card p-3">
                    <div class="card__name">
                        <div @click="addMembers(team)" class="team_name">{{team.name}}</div>
                        <div class="delete" @click="promptDeleteTeam(team.id)"><i class="fa fa-trash"></i></div>
                    </div>
                    <div class="pt-4 members" @click="addMembers(team)">
                        <div class="d-flex" v-if="team.members.length > 0">
                            <div class="d-flex position-relative stack-avatars">
                              <user-avatar
                                  v-for="(members,index) in team.members.slice(0,3)"
                                  :key="index"
                                  :avatarURL="members.avatar_src"
                              ></user-avatar>
                              <div v-if="team.members.length>3">{{
                                  team.members.length - 3
                                }}+</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <DeleteTeamPromptModal
                v-if="deletingTeam"
                :deleteTeamName="deleteTeamName"
                @close="resetForm"
                @confirm="deleteTeam"
            />
        </transition>
    </div>
</template>

<script>
    import DeleteTeamPromptModal from '../../Misc/Modal/DeleteTeamPromptModal'

    export default {
        components: { DeleteTeamPromptModal },
        data () {
            return {
                teams: {},
                leftCircle: null,
                deleteTeamId: '',
                deleteTeamName: '',
                deletingTeam: false,
            }
        },

        methods: {
            async getTeams () {
                const url = '/groups'
                const response = await axios.get(url)
                let newObj = {
                    leftValue: 0,
                }
                this.teams = response.data.data
                // this.teams = this.teams.concat(newObj);
                //   this.teams.push({...newObj});

                this.getLeftPosition
            },

            addMembers (team) {
                location.href = `/groups/${team.id}/add-members`
            },

            promptDeleteTeam(teamId) {
                this.deletingTeam = true
                this.deleteTeamId = teamId
                const team = this.teams.filter(item => item.id === teamId)
                this.deleteTeamName = team[0].name
            },

            resetForm () {
              this.deleteTeamId = ''
              this.deletingTeam = false
            },

            async deleteTeam() {
              await axios.delete(`/groups/${this.deleteTeamId}`);
              this.teams = this.teams.filter(item => item.id !== this.deleteTeamId);

              this.resetForm();
            }
        },

        mounted () {
            this.getTeams()
        },

        computed: {
            getLeftPosition () {
                this.leftCircle = 0
                this.leftCircle += 10
            },

            currentUser () {
                return this.$store.state.currentUser
            }
        },
    }
</script>

<style scoped lang="scss">
    .teams-list {
        &__title {
            color: #303030;
            font-family: Lato;
            font-size: 20px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 28px;
        }

        &__add {
            color: #303030;
            font-family: "Open Sans", sans-serif;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 22px;

            @media (max-width: 768px) {
                text-align: left;
                font-size: 14px;
            }

            i {
                color: #3592ff;
            }
        }

        .card {
            border: 1px solid rgba(194, 194, 194, 0.7);
            border-radius: 4px;
            background-color: #fbfbfb;
            height: 122px;

            &__name {
                display: flex;
                justify-content: space-between;
                color: #303030;
                font-family: "Open Sans";
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 22px;

                .team_name {
                    cursor: pointer;
                    width: 100%;
                }

                .delete {
                    color: #d0d0d0;
                    cursor: pointer;

                    &:hover {
                        color: #303030;
                    }
                }
            }

            .members {
                width: 100%;
                cursor: pointer;
            }
        }

        .col-6 {
            margin-bottom: 18px;
        }

        :root {
            --avatar-size: 40px;
        }
    }
</style>
